import { Inject, Injectable } from '@angular/core';
import { RestService } from 'src/app/core/services/rest.service';
import { BillingMilestoneModel, SubcontractorInvoiceModel } from '../project/project.models';
import { AggregatedEntriesByMonth } from './dashboard.model';

@Injectable({
    providedIn: 'root',
})
export class DashboardService {
    constructor(@Inject(RestService) private restService: RestService) {}

    public async getBillingMilestones(year: number): Promise<BillingMilestoneModel[]> {
        const path = `/dashboard/billingmilestones/${year}`;
        return await this.restService.get(path, {});
    }

    public async getSubcontractorInvoices(year: number): Promise<SubcontractorInvoiceModel[]> {
        const path = `/dashboard/subcontractorinvoices/${year}`;
        return await this.restService.get(path, {});
    }

    public async getEntriesByTypologies(year: number): Promise<AggregatedEntriesByMonth[]> {
        const path = `/dashboard/time/typologies/${year}`;
        return await this.restService.get(path, {});
    }

    public async getEntriesByActivities(year: number): Promise<AggregatedEntriesByMonth[]> {
        const path = `/dashboard/time/activities/${year}`;
        return await this.restService.get(path, {});
    }
}
